import { useGateValue } from '@statsig/react-bindings';

const useSAndR2025 = () => {
  return useGateValue('science_and_research_2025_rollout');
};

export default useSAndR2025;
